<i18n
  src="@/locales/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/cross_data.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<template>
  <div>
    <h1 class="page-title">
      <i class="fa-solid fa-box"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>
    <div class="flex flex-row justify-end">
      <tabs-download-buttons-packing-list
        :container_code="container_code"
        :container_id="container_id"
      />
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.producer") }}
                  </th>
                  <th
                    scope="col"
                    v-for="package_group in package_groups"
                    :key="package_group.id"
                    class="table-header-cell"
                  >
                    {{ package_group.pg_code }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr v-for="row in table_rows" :key="row.id" class="table-row">
                  <td class="table-cell-main">
                    {{ getProducerLabelByPackage(row) }}
                  </td>
                  <td
                    scope="col"
                    v-for="package_group in package_groups"
                    :key="package_group.id"
                    class="table-cell"
                  >
                    {{
                      row.package_groups.find(pg => pg.id == package_group.id)
                        ?.packages_quantity
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabsDownloadButtonsPackingList from "./DownloadButtonsPackingList.vue";

export default {
  name: "CrossDataTab",
  components: { TabsDownloadButtonsPackingList },
  data() {
    return {
      downloading: false
    };
  },
  props: {
    package_groups: {
      type: Array,
      required: true
    },
    container_id: {
      required: true
    },
    container_code: {}
  },
  computed: {
    packages: function () {
      let packages = [];
      this.package_groups.forEach(function (group) {
        packages = packages.concat(group.packages);
      });
      return packages;
    },
    table_rows: function () {
      let rows = [];
      this.packages.forEach(package_item => {
        let row = rows.find(row => this.findRow(row, package_item));
        let row_package_group = {
          id: package_item.package_group_id,
          packages_quantity: package_item.quantity
        };
        if (row) {
          let find_package_group = row.package_groups.find(
            pg => pg.id == package_item.package_group_id
          );

          if (find_package_group)
            find_package_group.packages_quantity += package_item.quantity;
          else row.package_groups.push(row_package_group);
        } else {
          row = {
            ...package_item,
            package_groups: [row_package_group]
          };
          rows.push(row);
        }
      });
      rows.sort((a, b) => this.sortByProviderAndPallet(a, b));
      return rows;
    }
  },
  methods: {
    findRow: function (row, package_item) {
      return (
        row.producer?.id == package_item.producer?.id &&
        row.organization?.id == package_item.organization?.id
      );
    },
    sortByProviderAndPallet: function (a, b) {
      let a_name = a.producer?.name || a.organization?.name;
      let b_name = b.producer?.name || b.organization?.name;
      return a_name.localeCompare(b_name);
    },
    getPackageGroupByPackage: function (package_item) {
      return this.getPackageGroupById(package_item.package_group_id);
    },
    getPGCodeByPackage: function (package_item) {
      let pg = this.getPackageGroupById(package_item.package_group_id);
      if (pg) return pg.pg_code;
      return "";
    },
    getProducerLabelByPackage: function (package_item) {
      if (package_item.producer && package_item.organization)
        return `${package_item.producer.name} (${package_item.organization.name})`;
      else if (package_item.producer) return package_item.producer.name;
      else if (package_item.organization) return package_item.organization.name;

      return "";
    }
  }
};
</script>
